import React from 'react';
import { buildProposalExportHtml, isSectionEmpty } from '../../utils/proposalExport';

export default function ProposalPreview({
  proposal,
  settings,
  isNewDocument,
  removeSpacing,
  subtotal,
  taxAmount,
  total,
  currency,
  isPublishedView,
  leftWidth,
  previewRef,
  businessProfile,
}) {
  const documentHtml = buildProposalExportHtml({
    proposal,
    settings,
    removeSpacing,
    subtotal,
    taxAmount,
    total,
    currency,
    businessProfile,
  });

  return (
    <div
      style={{ width: isPublishedView ? '100%' : `calc(${100 - leftWidth}% - 3px)` }}
      className={`bg-slate-200 border-l border-gray-300 overflow-y-auto p-4 sm:p-8 xl:p-12 ${
        isPublishedView ? 'block' : 'hidden xl:block'
      } flex-shrink-0 ${isPublishedView ? '' : 'min-w-[350px]'}`}
    >
      <style>{`
        .sow-content ul { list-style-type: disc !important; list-style-position: outside !important; padding-left: 1.5rem !important; margin-top: 0.5rem !important; margin-bottom: 0.5rem !important; color: inherit !important; }
        .sow-content ol { list-style-type: decimal !important; list-style-position: outside !important; padding-left: 1.75rem !important; margin-top: 0.5rem !important; margin-bottom: 0.5rem !important; color: inherit !important; }
        .sow-content li { display: list-item !important; margin-bottom: 0.35rem !important; padding-left: 0.5rem !important; font-size: inherit !important; line-height: inherit !important; }
        .sow-content ul ul, .sow-content ol ul { list-style-type: circle !important; }
        .sow-content p { margin-bottom: 0.5rem !important; }
      `}</style>
      <div
        ref={previewRef}
        style={{
          maxWidth: '800px',
          margin: '0 auto',
          boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
          background: '#ffffff',
        }}
        dangerouslySetInnerHTML={{ __html: documentHtml }}
      />
    </div>
  );
}